// Analytics Opt-Out Button für GA4
(function(a) {
    if (!a) return;
    a.style.cursor = "pointer";
    a.onclick = function() {
        gtag('consent', 'update', { 'ad_storage': 'denied', 'analytics_storage': 'denied' });
        localStorage.setItem('gaOptOut', 'true');
        alert('Google Analytics wurde deaktiviert.');
    };
})(document.querySelector("a[href='#gaOptOut']"));

// Event-Optionen für GA4
const eventOptions = function(action, page = location.pathname) {
    return {
        'event_name': action,
        'page_location': page
    };
};

// Google Analytics Form-Tracking für GA4
const gaFormTracking = function(event) {
    if (typeof gtag === 'undefined') return;
    var action = event.type.replace('wpcf7', 'form_');
    gtag('event', 'form_submission', {
        'form_event': action,
        'page_location': location.pathname
    });
};

// Contact Form 7 Events für GA4
jQuery('.wpcf7-form').on('wpcf7invalid wpcf7spam wpcf7mailsent wpcf7mailfailed wpcf7submit', gaFormTracking);